import type { FaireProductEntity } from "../../entity_types/product";

export const p_cx8e10aqb3: FaireProductEntity = {
  token: "p_cx8e10aqb3",
  type: "product",
  name: "Co-Pilot Dog Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3266920bbff76acb2ea54640c7d0ca7a9b542b1b0524994911df22408c59bbe9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89303cdfc4306c7c1158849d985b77c0621a7d3aa0c9ef9f10367cb32caf95de.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:11.263Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
